/* eslint-disable no-unused-vars */
import { useCallback, useMemo } from 'react';
import { SelectedItem } from './SelectedItem';
import * as S from './SelectedContent.styled';
import { Buttons } from 'components';

export const SelectedContent = ({
  uniqueIdToItemMap,
  includeSet,
  setIncludeSet,
  excludeSet,
  setExcludeSet,
  uniqueIdToItemMapFromServer,
  searchIdToItemMap,
  selectedItemsAfterSearch$,
  changesFlag,
}) => {
  const headerWidth = useMemo(() => {
    if (excludeSet.size) return 300;
    return 600;
  }, [excludeSet.size, includeSet.size]);

  const clearAllExcluded = useCallback(() => {
    setExcludeSet((newIncludeSet) => newIncludeSet.clear());
  }, []);

  const clearAllIncluded = useCallback(() => {
    setIncludeSet((newIncludeSet) => newIncludeSet.clear());
    setExcludeSet((newExcludeSet) => newExcludeSet.clear());
  }, []);

  if (!excludeSet.size && !includeSet.size) {
    return (
      <S.NoContent>
        <S.Header>Include:</S.Header>
        <p> Nothing Selected</p>
      </S.NoContent>
    );
  }

  return (
    <div>
      <S.HeaderWrap>
        <S.Header width={headerWidth} left>
          Include:
          <Buttons.TertiarySmall
            id='include_locations_clear_all'
            onClick={clearAllIncluded}
            style={{ marginLeft: 'auto', marginRight: '12px' }}
          >
            Clear All
          </Buttons.TertiarySmall>
        </S.Header>
        {excludeSet.size ? (
          <S.Header width={excludeSet.size ? 300 : 0} right>
            Exclude:
            <Buttons.TertiarySmall
              id='include_locations_clear_all'
              onClick={clearAllExcluded}
              style={{ marginLeft: 'auto', marginRight: '12px' }}
            >
              Clear All
            </Buttons.TertiarySmall>
          </S.Header>
        ) : null}
      </S.HeaderWrap>
      {uniqueIdToItemMap !== null && excludeSet && includeSet && uniqueIdToItemMapFromServer ? (
        <S.Box>
          <S.IncludeBox fullWidth={Boolean(excludeSet.size)}>
            {[...includeSet]?.map((id) => (
              <SelectedItem
                headerWidth={headerWidth}
                key={id}
                id={id}
                uniqueIdToItemMap={uniqueIdToItemMap}
                uniqueIdToItemMapFromServer={uniqueIdToItemMapFromServer}
                searchIdToItemMap={searchIdToItemMap}
                selectedItemsAfterSearch$={selectedItemsAfterSearch$}
                env='include'
                includeSet={includeSet}
                setIncludeSet={setIncludeSet}
                excludeSet={excludeSet}
                setExcludeSet={setExcludeSet}
                changesFlag={changesFlag}
              />
            ))}
          </S.IncludeBox>
          {excludeSet.size ? (
            <S.ExcludeBox>
              {[...excludeSet]?.map((id) => (
                <SelectedItem
                  headerWidth={headerWidth}
                  key={id}
                  id={id}
                  uniqueIdToItemMap={uniqueIdToItemMap}
                  uniqueIdToItemMapFromServer={uniqueIdToItemMapFromServer}
                  searchIdToItemMap={searchIdToItemMap}
                  selectedItemsAfterSearch$={selectedItemsAfterSearch$}
                  env='exclude'
                  includeSet={includeSet}
                  setIncludeSet={setIncludeSet}
                  excludeSet={excludeSet}
                  setExcludeSet={setExcludeSet}
                  changesFlag={changesFlag}
                />
              ))}
            </S.ExcludeBox>
          ) : null}
        </S.Box>
      ) : (
        <p>...Loading</p>
      )}
    </div>
  );
};
